<template>
    <b-modal
        id="pws-video-modal"
        v-model="modal"
        modal-class="apprentice-default-modal pws-video-modal"
        ok-only
        hide-header
        :ok-title="$t('common.close')"
        :title="title"
        size="lg">
        <div class="player">
            <b-embed
                type="iframe"
                aspect="16by9"
                :src="`https://www.youtube.com/embed/${videoId}`"
                allowfullscreen
                ref="player">
            </b-embed>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-profile-paper-index-video-modal-components',
    data() {
        return {
            title: '',
            videoId: '',
            modal: false,
        };
    },

    methods: {
        show(videoId, videoTitle) {
            this.videoId = videoId;
            this.title = videoTitle;
            this.modal = true;
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep .pws-video-modal {
    .modal-body {
        padding: 0;
    }
}
</style>
